











































































































































import {Component, Vue, Prop} from "vue-property-decorator"
import axios, {AxiosResponse} from "axios";
import AuthApi from "@/api/AuthApi";
@Component({})
export default class ModalAddDomains extends Vue {
  public showPopup: boolean = false
  public isLoaded: boolean = false

  public domainName: string = ''
  public domainsHostingURL: string = ''
  public domainHostingLogin: string = ''
  public domainHostingPass: string = ''
  public domainsRegisterURL: string = ''
  public domainRegisterLogin: string = ''
  public domainRegisterPass: string = ''
  public domainPrice: string = ''
  public domainDate: string = ''
  public domainsHostingService: boolean = true
  public domainsRegisterService: boolean = true

  created(){
    (window as any).modalAdd = this
  }

  show(){
    this.showPopup = true
    this.$forceUpdate()
  }

  hide(){
    this.showPopup = false
    this.$forceUpdate()
  }

  private async submitDomains(){
    const data = {
      domain: this.domainName,
      paidDate: this.domainDate,
      domainUrl: this.domainsRegisterURL,
      domainLogin: this.domainRegisterLogin,
      domainPass: this.domainRegisterPass,
      hostUrl: this.domainsHostingURL,
      hostLogin: this.domainHostingLogin,
      hostPass: this.domainHostingPass,
      price: this.domainPrice,
      serviceDomain: this.domainsRegisterService,
      serviceHost: this.domainsHostingService,
      active: true
    }
    if (this.domainName != ''){
      this.isLoaded = true
      // @ts-ignore
      const store: any = JSON.parse(localStorage.getItem('session'))
      if (store.token){
        await axios.post(AuthApi.API_URL + '/api/domains', data, {
          headers: {
            'authorization': 'Bearer ' + store.token
          }
        })
            .then((res) => {
              if (res.data.status == true){
                alert(res.data.message)
                this.domainName = '';
                this.domainDate = '';
                this.domainsRegisterURL = '';
                this.domainRegisterLogin = '';
                this.domainRegisterPass = '';
                this.domainsHostingURL = '';
                this.domainHostingLogin = '';
                this.domainHostingPass = '';
                this.domainPrice = '';
                this.isLoaded = false;
                (window as any).domains.getDomains();
                this.$forceUpdate();
              } else {
                this.isLoaded = false;
                alert(res.data.message)
              }
            })
            .catch(e => {
              this.isLoaded = false;
              localStorage.removeItem('session')
              this.$router.push('/login')
            })
      }
    }
  }

}

